export const SET_REGIONAL_POWER_CONTACT = 'main/SET_REGIONAL_POWER_CONTACT'

export const SET_FEEDBACK_ACTION = 'main/SET_FEEDBACK_ACTION'
export const SET_FEEDBACK_ACTION_DONE = 'main/SET_FEEDBACK_ACTION_DONE'
export const SET_FEEDBACK_ACTION_FAIL = 'main/SET_FEEDBACK_ACTION_FAIL'
